import ccesV3Extensions, { settings as ccesSettings } from './ccesV3Extensions';
import getCreativeCloudLink, { settings as getCreativeCloudLinkSettings } from './get-ccd-link';
import getCountries from './get-countries';
import getIndustries from './get-industries';
import getInstructionTemplates from './get-instruction-templates';
import getStandardTags from './get-standard-tags';
import getCCMostPopularTags, { settings as ccMostPopularTagsSettings } from './getCCMostPopularTags';
import getLanguages, { settings as languagesSettings } from './getLanguages';
import staticData, { settings as staticDataSettings } from './staticData';

export default {
  staticData,
  staticDataSettings,
  ccesV3Extensions,
  ccesSettings,
  getCCMostPopularTags,
  ccMostPopularTagsSettings,
  getLanguages,
  languagesSettings,
  getCreativeCloudLink,
  getCreativeCloudLinkSettings,
  getStandardTags,
  getCountries,
  getIndustries,
  getInstructionTemplates,
};
